"use client";

import { MobileSidebarToggle } from "@/components/mobile-sidebar-toggle";

type PowerOnProLayoutProps = {
  children: React.ReactNode;
};

export default function PowerOnProLayout({ children }: PowerOnProLayoutProps) {
  return (
    <div className="flex h-full flex-col overflow-hidden bg-background">
      <MobileSidebarToggle layoutName="PowerOn Pro" />
      <div className="lb-scrollbar-overlay flex-1 overflow-x-hidden overscroll-y-auto bg-background [container-name:poweron-pro] [container-type:inline-size]">
        <div className="pb-8 pl-3.5 pr-1 pt-5 sm:mx-auto sm:max-w-5xl sm:px-6 sm:pt-7">
          {children}
        </div>
      </div>
    </div>
  );
}
